<section class="regular-user-home pt-9 pr-6">
  <div class="button-container">
    <gbui-button
      (click)="changeToAdmin()"
      *showOnRole="'company-administrator'"
      class="buttons-outline"
    >
      Account Administration
    </gbui-button>
  </div>
  <div class="main-container">
    <div class="main-container-modules">
      <div class="module-cards-container">
        <div
          class="card-modules"
          [ngClass]="{ 'disable-content': isExpired }"
          [routerLink]="[modules[0].link]"
        >
          <div class="counter-container">
            <ng-container>
              <ng-template [ngIf]="!(requestsLoading$ | async)">
                <div class="counter" *ngIf="+requestsCount > 0">
                  <label for="">{{ requestsCount }}</label>
                </div>
              </ng-template>

              <ng-template [ngIf]="requestsLoading$ | async">
                <div class="counter" *ngIf="modules[0].title == 'Request'">
                  <!-- <div class="counter" *ngIf="modules[0].title == 'Request'"> -->
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
              </ng-template>
            </ng-container>
          </div>
          <div class="module-icon">
            <div class="module-icon-container">
              <label for="">{{ modules[0].title }}</label>
              <img src="{{ modules[0].icon }}" alt="" />
            </div>
          </div>
        </div>

        <div
          class="card-modules"
          [ngClass]="{ 'disable-content': isExpired }"
          [routerLink]="[modules[1].link]"
        >
          <div class="counter-container">
            <ng-container>
              <ng-template [ngIf]="!(approvesLoading$ | async)" let-approves>
                <div class="counter" *ngIf="+approverCount > 0">
                  <label for="">{{ approverCount }}</label>
                </div>
              </ng-template>

              <ng-template [ngIf]="approvesLoading$ | async">
                <div class="counter" *ngIf="modules[1].title == 'Request'">
                  <!-- <loader></loader> -->
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
              </ng-template>
            </ng-container>
          </div>
          <div class="module-icon">
            <div class="module-icon-container">
              <label for="">{{ modules[1].title }}</label>
              <img src="{{ modules[1].icon }}" alt="" />
            </div>
          </div>
        </div>
        <div class="card-modules" [routerLink]="[modules[2].link]">
          <div class="module-icon">
            <div class="module-icon-container">
              <label for="">{{ modules[2].title }}</label>
              <img src="{{ modules[2].icon }}" alt="" />
            </div>
          </div>
        </div>

        <div class="card-modules" [routerLink]="[modules[3].link]">
          <div class="module-icon">
            <div class="module-icon-container">
              <label for="">{{ modules[3].title }}</label>
              <img src="{{ modules[3].icon }}" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
